export default __webpack_public_path__ + "static/media/640_dummy2016-illustrator01-mobile-de.a5f0f090.png";